exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msg-screen {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 4;\n  background-color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  align-items: center; }\n  .msg-screen__content {\n    width: 100%;\n    max-width: 600px;\n    margin: 0 auto; }\n", ""]);

// exports
